import React,{useState} from 'react'
import StickerImg from '../../images/sticker.jpg'
import productList from '../../util/products.json'
export default function ItemCart() {
    const [unit, setUnit] = useState(1)
    const onClick2AddSticker=()=>{
      console.log(window.localStorage.getItem('shopping-cart'))
      const x2 = JSON.parse(window.localStorage.getItem('shopping-cart'))
      //1-1 Item is already at storage
      if (x2!=null) {
        const update = x2.find((x)=>x.id==0)
      //2-1 Update with other items at local storage
      //3-1 Update with other items at render cart
      if(update&&x2.length>1){
        const otherItems = x2.find((x)=>x.id!=0)
        const y2 = [...otherItems, {"id":0,"product_name":"sticker","unit":unit,"price":7,"img":StickerImg}]
        return window.localStorage.setItem('shopping-cart', JSON.stringify(y2))
      //2-2 Update item at local storage
      }else if(update) {
        return window.localStorage.setItem('shopping-cart', JSON.stringify([{"id":0,"product_name":"sticker","unit":unit,"price":7,"img":StickerImg}]))
      }
      //1-2 Item is not at storage
      }else {
        window.localStorage.setItem('shopping-cart', JSON.stringify([{"id":0,"product_name":"sticker","unit":unit,"price":7,"img":StickerImg}]))
      }
    }
    const onClick2AddCodeProduct=(x1)=>{
      const x2=JSON.parse(window.localStorage.getItem('shopping-cart'))
      if (x2) {
        const existedItem = x2.find((x)=>x.id==x2)
        if(!existedItem){
          return window.localStorage.setItem('shopping-cart', JSON.stringify([...x2, {"id":x1.id,"product_name":x1.product_name,"unit":1,"price":x1.price,"img":x1.img}]))
        }
      }else {
        window.localStorage.setItem('shopping-cart', JSON.stringify([{"id":x1.id,"product_name":x1.product_name,"unit":1,"price":x1.price,"img":x1.img}]))
      }
    }
    const onChange2NumberToGenerate = (e) => {setUnit(e.target.value)}
    return(
        <>
        <div className='structure__main__subttl'>Item Cart page</div>
        <div className='flex'>
        <div className='structure__item__container'>
        <img src={StickerImg} className='w-20'/>
        <div className='flex text-xs mt-2 mb-1'>
          <div className='structure__item__ttl'>Sticker $7.00 x 
          <select
            onChange={onChange2NumberToGenerate}
            name='generatenumber'
            className='ml-1 border border-gray-950'
          >
            {Array.from(Array(100), (e, i) => {
            return <option value={`${i+1}`}>{i+1}</option>
            })}
          </select>
          </div>
        </div>
        <p className='text-xs'>*Shipment fee is already included.</p>
        <button className='secondary-btn' onClick={onClick2AddSticker}>Add to cart</button>
        </div>
        {productList.code_products.map((x)=>(<div>
        <div className='structure__item__container'>
        <br/>
        {/* {`https://placehold.co/200x100?text=Code${x.id}`} */}
        <img src={x.img} className='w-20'/>
        <br/>
        <div className='text-xs text-left'>
           <div className='structure__item__ttl'>Code#{x.id} {x.product_name}
           </div>
           <div className='structure__item__price text-right'>US${x.price}</div>
        </div>
        <button className='secondary-btn' onClick={()=>onClick2AddCodeProduct(x)}>Add to cart</button>
        </div>
        </div>))}
        </div>
        <br/>
        </>
    )
}